import { useNodes } from "reactflow"
import { useMemo } from "react"
import { getLayerBands } from "../layout"

interface Props {
  direction: "TB" | "LR" | "manual" | "radial"
}

export function LayerBands({ direction }: Props) {
  const nodes = useNodes()

  const bands = useMemo(() => {
    if (nodes.length === 0) return []
    return getLayerBands(nodes, direction)
  }, [nodes, direction])

  if (bands.length === 0) return null

  const isVertical = direction === "TB"

  // Find the full cross-axis range for band width
  const crossPositions = nodes.map((n) => (isVertical ? n.position.x : n.position.y))
  const crossMin = Math.min(...crossPositions) - 80
  const crossMax = Math.max(...crossPositions) + 320

  return (
    <svg className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-visible">
      <g className="layer-bands">
        {bands.map((band) => {
          if (isVertical) {
            return (
              <g key={band.layerId}>
                {/* Band background */}
                <rect
                  x={crossMin}
                  y={band.start}
                  width={crossMax - crossMin}
                  height={band.end - band.start}
                  fill={band.color}
                  opacity={0.04}
                  rx={8}
                />
                {/* Layer label */}
                <text
                  x={crossMin + 8}
                  y={band.start + 16}
                  fill={band.color}
                  opacity={0.5}
                  fontSize={11}
                  fontWeight={700}
                  letterSpacing="0.1em"
                >
                  {band.layerName.toUpperCase()}
                </text>
              </g>
            )
          } else {
            return (
              <g key={band.layerId}>
                <rect
                  x={band.start}
                  y={crossMin}
                  width={band.end - band.start}
                  height={crossMax - crossMin}
                  fill={band.color}
                  opacity={0.04}
                  rx={8}
                />
                <text
                  x={band.start + 8}
                  y={crossMin + 16}
                  fill={band.color}
                  opacity={0.5}
                  fontSize={11}
                  fontWeight={700}
                  letterSpacing="0.1em"
                >
                  {band.layerName.toUpperCase()}
                </text>
              </g>
            )
          }
        })}
      </g>
    </svg>
  )
}
